<template>
  <div class="teacher">
    <div class="innerBox">
      <div class="close" @click="close">
        <img src="../assets/close.png" />
      </div>
      <div class="title">
        <span>{{title}}</span>
      </div>
      <div class="content">
        <span>{{content}}</span>
      </div>
      <div class="codeBox" v-show="noTeacher">
        <img :src="code" />
        <span>{{teacherName || publicBottom}}</span>
      </div>
      <div class="info" v-show="!noTeacher">
        <span>还没有你的班主任信息哦</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      code: "",
      noTeacher: false,
      teacherName: ""
    };
  },
  props: {
    title: String,
    content: String,
    publicBottom: String,
    showPackage: Object
  },
  methods: {
    close() {
      this.$emit("close", false);
    }
  },
  mounted() {},
  watch: {
    showPackage(val) {
      if (this.title === "班主任") {
        this.axios
          .get(`/v1/api/self/scratch/packages/${val._id}/classmanager`)
          .then(res => {
            this.noTeacher = true;
            this.code = res.data.classmanager.qrCode;
            this.teacherName = `专属班主任：${res.data.classmanager.name}`;
          })
          .catch(err => {
            this.noTeacher = false;
          });
      } else if (this.title === "关注公众号") {
        this.axios
          .get(`/v1/api/self/scratch/packages/${val._id}/wechatqrcode`)
          .then(res => {
            this.code = res.data.qrcode;
            this.noTeacher = true;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin wh($w: 100%, $h: 100%) {
  width: $w;
  height: $h;
}
@mixin flexCenter() {
  display: flex;
  align-items: center;
  justify-content: center;
}
@mixin flexColumn() {
  display: flex;
  flex-direction: column;
}
@mixin marginAuto() {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.teacher {
  @include wh();
  position: absolute;
  background-color: rgba(#000000, 0.7);
  left: 0;
  top: 0;
  z-index: 9999;
}
.innerBox {
  @include wh(527px, 420px);
  @include marginAuto();
  @include flexColumn();
  min-width: 700px;
  border-radius: 30px;
  background-color: #fff;
  padding: 15px 25px;
  box-sizing: border-box;
  align-items: center;
  background-image: url("../assets/teacher_public.png");
  background-position: left bottom;
  background-size: cover;
}
.close {
  @include wh(94px, 94px);
  position: absolute;
  top: -47px;
  right: -50px;
  cursor: pointer;
  img {
    @include wh();
  }
}
.title {
  @include wh(100%, 60px);
  @include flexCenter();
  span {
    font-size: 28px;
    color: #fda90a;
  }
}
.content {
  @include wh(100%, 60px);
  text-align: center;
  line-height: 60px;
  span {
    font-size: 22px;
    color: #5e5e5e;
  }
}
.codeBox {
  @include flexColumn();
  padding: 20px 7px;
  align-items: center;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0px 0px 13px 0px rgba(255, 156, 6, 0.5);
  margin-top: 15px;
  img {
    @include wh(150px, 150px);
  }
  span {
    width: 150px;
    text-align: center;
    color: #5e5e5e;
    font-size: 13px;
  }
}
.info {
  height: 200px;
  line-height: 200px;
}
</style>
